import * as React from 'react';
import { Text, Modal, Button, Heading, CloseButton } from 'wix-style-react';
import s from './NoWebsiteModal.scss';
import { useTranslation } from 'react-i18next';
import { RootStore, withInjectedRootStore } from '../../../providers';
import { UiProvider } from '../../../providers/UiProvider';
import classNames from 'classnames';
import { Theme } from '../../../enums';

interface NoWebsiteModalProps {
  isOpen: boolean;
  onClose(): void;
  rootStore: RootStore;
}
const EditorXTemplatePageURL = 'https://www.editorx.com/templates';
const WixTemplatePageURL = '/website/templates';
const NoWebsiteModalComp: React.FC<NoWebsiteModalProps> = ({
  isOpen,
  onClose,
  rootStore,
}) => {
  const handleConfirmation = () => {
    const { isEditorX } = rootStore.appStore;
    window.location.assign(
      isEditorX ? EditorXTemplatePageURL : WixTemplatePageURL,
    );
  };
  return (
    <Modal dataHook='no-website-modal' isOpen={isOpen}>
      <ModalContent onClose={onClose} onConfirm={handleConfirmation} />
    </Modal>
  );
};

export interface ModalContentProps {
  onClose(): void;
  onConfirm(): void;
}

export const ModalContent: React.FC<ModalContentProps> = ({
  onClose,
  onConfirm,
}) => {
  const { t } = useTranslation();

  return (
    <UiProvider>
      {({ themeName }) => (
        <div className={s.modalContainer}>
          <div className={s.header}>
            <CloseButton
              onClick={onClose}
              size='large'
              skin='dark'
              dataHook='close-button'
            />
          </div>
          <div className={s.modalBody}>
            <div className={classNames(s.image, themeName)}></div>
            <Heading
              dataHook='no-website-modal-title'
              appearance='H2'
              className={s.title}
            >
              {t('no_sites_modal.title')}
            </Heading>
            <Text dataHook='no-website-modal-subtitle'>
              {t(
                themeName === Theme.EditorX
                  ? 'editorx.no_sites_modal.subtitle'
                  : 'no_sites_modal.subtitle',
              )}
            </Text>
            <Button
              onClick={onConfirm}
              dataHook='confirm-button'
              data-testid='confirm-button'
              className={s.btn}
            >
              {t('no_sites_modal.cta')}
            </Button>
          </div>
        </div>
      )}
    </UiProvider>
  );
};

export const NoWebsiteModal = withInjectedRootStore(NoWebsiteModalComp);
